"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SHIMMER_CONTINUE_SEARCH = exports.ARR_COLUMN_SPAN = void 0;
var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaClassic/theme"));
var ARR_COLUMN_SPAN = ['2', '3', '4'];
exports.ARR_COLUMN_SPAN = ARR_COLUMN_SPAN;
var DEFAULT_SHIMMER_CONTINUE_SEARCH = {
  COLUMNSPAN: '3',
  BORDER_RADIUS: _theme.default.borderRadius.normal
};
exports.DEFAULT_SHIMMER_CONTINUE_SEARCH = DEFAULT_SHIMMER_CONTINUE_SEARCH;